function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M69.2 0C30.9843 0 0 30.9843 0 69.2C0 107.416 30.9843 138.4 69.2 138.4C107.416 138.4 138.4 107.416 138.4 69.2C138.4 30.9843 107.416 0 69.2 0ZM107.877 55.977L64.281 99.573C63.1969 100.657 61.7322 101.263 60.204 101.263C58.6758 101.263 57.2053 100.657 56.127 99.573L36.2147 79.6607C33.9599 77.406 33.9599 73.7614 36.2147 71.5067C38.4694 69.2519 42.114 69.2519 44.3687 71.5067L60.204 87.3419L99.723 47.823C101.978 45.5682 105.622 45.5682 107.877 47.823C110.132 50.0777 110.132 53.7223 107.877 55.977Z",
  fill: "white"
});

function SvgOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.7fcab9a6.svg";
export { ForwardRef as ReactComponent };